import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputFile, InputPicklist } from '../../components';
import BaseCopy from '../base/base-copy.component'; 
import Model from './quizanswer-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import QuizresultChecklist from '../quizresult/quizresult-checklist.component';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class QuizanswerCopy extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  {...data, id: null, image: null, imageUrl: ''}});
    } 

    private onLoadQuizresult = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'quizresult': data || [], 'quizresultCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }  

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseCopy history={this.props.history} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError}>              
                
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                <Input name='title' label='Title' value={this.state.datarow.title} error={this.state.errors?.title} onChange={this.onChange} />
                <InputMultiline name='content' label='Content' value={this.state.datarow.content} error={this.state.errors?.content} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                <Input name='answer' label='Answer' value={this.state.datarow.answer} error={this.state.errors?.answer} onChange={this.onChange} />
                <InputNumber name='value' label='Value' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                <InputPicklist name='quizresult' label='Quiz Result List' value={this.state.datarow.quizresult} caption={this.state.datarow.quizresultCaption} disableAutoClose clearValue={this.onLoadQuizresult} error={this.state.errors?.quizresult} onChange={this.onChange} >
                    <QuizresultChecklist history={this.props.history} currentId={this.state.datarow.quizresult} onLoad={this.onLoadQuizresult} disableBackButton/>
                </InputPicklist> 
            </BaseCopy>
        );
    }
}